import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgMailBlack = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 12,
	viewBox: "0 0 14 12",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "evenodd",
		d: "M12.333.667H1.667C.933.667.34 1.267.34 2l-.007 8c0 .733.6 1.333 1.334 1.333h10.666c.734 0 1.334-.6 1.334-1.333V2c0-.733-.6-1.333-1.334-1.333zm0 2.666L7 6.667 1.667 3.333V2L7 5.333 12.333 2v1.333z"
	}) })
});
export default SvgMailBlack;
